import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../../../../common/html/element'
import { SCREEN } from '../../../../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { DefaultVsicName } from '../../../../../DefaultVsicName'
import { Content } from './Content'
import { ShowAllIndustry } from './ShowAllIndustry'

export const ChartValue = () => {
  const { formatedUnit } = useFormatCurrency(SCREEN.INDUSTRY_OVERVIEW)

  return (
    <div className="h50 flexColumn">
      <div className="dFlex justifyContentBetween">
        <div className="fw600">
          <Translate value="industryOverview.macroeconomics.IMPORT_EXPORT_TRADE_VALUE" />
          :
        </div>
        <ShowAllIndustry />
      </div>
      <DefaultVsicName />
      <Element className="mt1" style={{ color: '#9C9C9C' }}>
        {formatedUnit}
      </Element>

      <div className="flex1">
        <Content />
      </div>

      <div
        style={{
          position: 'fixed',
          top: -1000,
          left: -2000,
          width: 1000,
          height: 600,
        }}
        id="macroImportExportValueId"
      >
        <Content />
      </div>
    </div>
  )
}
